export const NAV_ICON_TEXT_GAP = 1;
